import {useQuery} from '@tanstack/react-query';
import {GetTelehealthDocsParams} from 'domain/usecases';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getAppointmentsTelehealthDocs} from '../../services/getAppointmentsTelehealthDocs';

export const useGetAppointmentsTelehealthDocsQuery = (params: GetTelehealthDocsParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.APPOINTMENTS_TELEHEALTH_DOCS, params],
		queryFn: ({signal}) => getAppointmentsTelehealthDocs({signal, ...params}),
		enabled: !!params.health_requester_id,
	});
